import React from 'react';
import listado from '../components/Admin/Suppliers/ListSuppliers'

import './home.scss';

export default function Home() {
	return (
		<div class="container">
			<div class="row">
				<div class="col-lg-3 col-sm-6">
					<div class="card-box bg-blue">
						<div class="inner">
							<h3> Bienvenido al Portal de Proveedores ICONTEC. </h3>
							<p>Para empezar, haz clic en consultas.</p>
							<p>O</p>
							<p>Actualice sus datos.</p>
						</div>
						<div class="icon">
							<i class="fa fa-graduation-cap" aria-hidden="true"></i>
						</div>
											


					</div>
				</div>
			</div>
		</div>
	);
}
